import { render, staticRenderFns } from "./PhoneSelect.vue?vue&type=template&id=16971a78"
import script from "./PhoneSelect.vue?vue&type=script&lang=js"
export * from "./PhoneSelect.vue?vue&type=script&lang=js"
import style0 from "./PhoneSelect.vue?vue&type=style&index=0&id=16971a78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports